<template>
  <el-container>
    <el-aside width="220px">
      <el-tree ref="tree" :data="parameterTypeTree" :props="{ value: 'type_id',label: 'type_desp', children: 'child'}" @node-click="handleNodeClick" />
    </el-aside>
    <el-main>
      <params-list v-if="parameterTypeList.length" :rowData="rowData" :isControllable="isControllable" :parameterTypeList="parameterTypeList" />
    </el-main>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import list from './list'

export default {
  name: '',
  data () {
    return {
      treeNodeIdSelect: null,
      parameterTypeTree: [],
      parameterTypeList: []
    }
  },

  components: {
    'params-list': list
  },

  props: ['rowData', 'isControllable'],

  created () {
    this.getParameterTypeTree(this.rowData.device_type_id)
  },

  methods: {
    getParameterTypeTree (id) {
      Backend.post(this, 'device/parameter_type_tree', { device_type_id: id }).then((res) => {
        this.parameterTypeTree = res.items
      })
    },
    handleNodeClick (data, node) {
      // console.log(data, node)

      if (!data.child) {
        console.log(data, node)
        if (data.$treeNodeId === this.treeNodeIdSelect) return
        this.treeNodeIdSelect = data.$treeNodeId
        const arr = [data.type_id]
        this.parameterTypeList = this.getAllParams(node, arr)
      }
    },
    getAllParams (node, arr) {
      if (node.parent && node.parent.level > 0) {
        arr.unshift(node.parent.data.type_id)
        this.getAllParams(node.parent, arr)
      }
      return arr
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-aside{
    height: 444px;
    overflow: auto;
    border-right: 1px solid #e4e4e4;
    padding-right: 10px;
  }
  .el-main{
    padding: 0 10px;
  }
</style>
